import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {datadogRum} from '@datadog/browser-rum';
import mixpanel from 'mixpanel-browser';
import {ThemeProvider} from '@sunbit-dev/web-ui-lib';
import {initConfig} from '@sunbit-dev/common/services/config';
import httpClient from '@sunbit-dev/common/services/httpClient';
import App from './containers/App'
import sunbitApi from './services/SunbitApi';
import {AppContextProvider} from "./contexts/appContext";
import LoaderContextProvider from "./contexts/loaderContext";
import './app.css';

declare const window: Window & { sunbitEnv: string };

(async () => {
  const configService = await initConfig(window.sunbitEnv, '/config');

  httpClient.setBaseUrl(configService.getItem('apiUrl'));
  sunbitApi.init(httpClient);

  if (window.sunbitEnv !== "automation") {
    datadogRum.init({
      applicationId: '2c756f00-ac62-46b2-a99f-e82f789235d',
      clientToken: 'pub8aee01d2d5dbd323bc7a2fc9ec6a108b',
      site: 'datadoghq.com',
      env: window.sunbitEnv,
      service: 'developers-portal',
      version: '1.0.0',
      sampleRate: 100,
      trackInteractions: true
    });
  }
  

  if (window.sunbitEnv === "oregon-prod") {
    mixpanel.init(configService.getItem('mixpanelToken'), {api_host: "https://mixpanel-proxy.sunbit.com"});
  } else {
    mixpanel.init(configService.getItem('mixpanelToken'), {api_host: "https://mixpanel-proxy.sunbit.in"});
  }

  ReactDOM.render(
    <Router>
      <AppContextProvider>
        <ThemeProvider>
          <LoaderContextProvider>
            <App docsUrl={configService.getItem('docsUrl')}/>
          </LoaderContextProvider>
        </ThemeProvider>
      </AppContextProvider>
    </Router>
    , document.getElementById('root'));
})();
